import React from 'react';
import { Modal, Button, Text } from '@companycam/slab-web';
import { translate } from 'javascripts/translations/i18n';

type DeleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  title?: string;
  message?: string;
};

const DeleteModal = ({
  isOpen,
  onClose,
  onDelete,
  title,
  message,
}: DeleteModalProps) => {
  return (
    <Modal
      title={title || translate('common.delete')}
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      footerActions={
        <>
          <Button onClick={onClose} data-testid="delete-modal__cancel">
            {translate('common.cancelDelete')}
          </Button>
          <Button
            color="destroy"
            onClick={() => {
              onDelete();
              onClose();
            }}
            data-testid="delete-modal__confirm"
          >
            {translate('common.confirmDelete')}
          </Button>
        </>
      }
    >
      <Text data-testid="delete-modal__content" as="p">
        {message || translate('common.confirmDeleteMessage')}
      </Text>
    </Modal>
  );
};
export default DeleteModal;
